import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import "./About.scss";
import about_ko from "./json/about_ko.json";
import about_en from "./json/about_en.json";

function About() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const about_data = lang === "en" ? about_en : about_ko;
  const { main_title, navbar_links, sub_titles, intro_pars, faqs } = about_data;

  const navigate = useNavigate();
  const [about, setAbout] = useState(false);

  return (
    <div className="about-root">
      <div className="about-header">
        <div className="about-header-title">{main_title}</div>
        <div className="about-header-links">
          <div className="about-header-link" onClick={() => navigate("/")}>
            {navbar_links[0]}
          </div>
          {/* <div className="about-header-link" onClick={() => setAbout(true)}> */}
          <div className="about-header-link" onClick={() => navigate("/demo")}>
            {navbar_links[1]}
          </div>
          <div className="about-header-link" onClick={() => setAbout(false)}>
            {navbar_links[2]}
          </div>
        </div>
      </div>
      <div className="about-body">
        <div className="about-body-game">
          <div className="about-body-game-title">{about ? sub_titles[0] : sub_titles[1]}</div>
          <div className="about-body-game-text">
            {about
              ? intro_pars.map((p, i) => <div key={i}>{p ? p : <br />}</div>)
              : faqs.map((q, i) => (
                  <Accordion key={i}>
                    <AccordionSummary
                      expandIcon={<Typography>{"⇓"}</Typography>}
                      sx={{ backgroundColor: "#f9fbff" }}
                    >
                      <div className="about-body-game-faq-title">{q.question}</div>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#f9fbff" }}>
                      <div className="about-body-game-faq-text">
                        {q.ans_pars.map((p, j) => (
                          <div key={`${i}.${j}`}>
                            {p ? (
                              typeof p == "string" ? (
                                p
                              ) : p?.tag === "img" ? (
                                <img className={p.class} src={p.src} />
                              ) : null
                            ) : (
                              <br />
                            )}
                          </div>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
